import React, { useRef, useImperativeHandle, createElement } from 'react';
import classnames from 'classnames';
import { Carousel } from 'antd';
import { checkOddEvenIndex, default_icon, useCachedIcons } from '../../utils';
import './index.less';
const ScrollTable = React.forwardRef((props, ref) => {
    const contentRef = useRef(null);
    const { index, dataIndex, carouselConfig, indexHeader, columns, showHeader, headerBGC, headerColor, dataSource, size, indexWidth, showIcon, oddRowBGC, evenRowBGC, rowColor, style, icons = default_icon, highlight, onRowClick, } = props || {};
    const cachedIcons = useCachedIcons(icons);
    const config = {
        dots: false,
        effect: 'scrollx',
        infinite: true,
        vertical: true,
        slidesToShow: 4,
        autoplay: true,
        ...carouselConfig,
    };
    const defaultIndexWidth = typeof indexWidth === 'number' ? `${indexWidth}px` : indexWidth || '50px';
    const gridTemplateColumns = React.useMemo(() => {
        const columnWidths = columns
            .map((item) => (typeof item.width === 'number' ? `${item.width}px` : item.width || '1fr'))
            .join(' ');
        return index ? `${defaultIndexWidth} ${columnWidths}` : columnWidths;
    }, [columns, index, defaultIndexWidth]);
    useImperativeHandle(ref, () => ({}));
    const renderHeader = () => {
        if (!showHeader) {
            return null;
        }
        const headStyle = {
            backgroundColor: headerBGC,
            color: headerColor,
        };
        return (createElement("div", { className: "header", style: {
                gridTemplateColumns,
                ...headStyle,
            } },
            index ? createElement("div", { className: "header-item" }, indexHeader || '#') : null,
            columns?.map((col, i) => {
                return (createElement("div", { key: col?.key || col?.dataIndex || i, className: classnames('header-item', {
                        [`align-${col.align}`]: !!col.align,
                    }) }, col.title));
            })));
    };
    const renderIndex = (_i) => {
        if (!index) {
            return null;
        }
        const icon = cachedIcons?.[_i];
        const highlighted = highlight >= _i + 1;
        return (createElement("div", { className: "ceil" }, icon && showIcon && highlighted ? (createElement("span", null,
            createElement("img", { src: icon, width: "24px", height: "24px" }))) : (createElement("span", { className: classnames('index', {
                highlighted: !!highlighted,
            }) }, _i + 1))));
    };
    const renderCeil = (record, _index) => {
        const rowStyle = {
            gridTemplateColumns,
            background: checkOddEvenIndex(_index + 1) ? evenRowBGC : oddRowBGC,
            color: rowColor,
        };
        const $index = dataIndex ? record[dataIndex] : _index;
        return (createElement("div", { className: "row-item", onClick: () => {
                onRowClick?.(record, _index);
            }, style: {
                ...rowStyle,
            } },
            renderIndex($index),
            columns?.map((col, _i) => {
                const value = col?.dataIndex ? record?.[col?.dataIndex] : null;
                return (createElement("div", { key: _i, className: classnames('ceil', {
                        [`align-${col.align}`]: !!col.align,
                    }) }, col?.render ? col.render?.(value, record, _index) : value));
            })));
    };
    const renderContent = () => {
        if (dataSource?.length <= carouselConfig.slidesToShow) {
            return (createElement(React.Fragment, null, dataSource?.map((record, _index) => {
                return (createElement(React.Fragment, { key: `row-${_index.toString()}` }, renderCeil(record, _index)));
            })));
        }
        return (createElement(Carousel, { ...config, ref: contentRef }, dataSource?.map((record, _index) => {
            return (createElement(React.Fragment, { key: `row-${_index.toString()}` }, renderCeil(record, _index)));
        })));
    };
    return (createElement("div", { className: classnames('dv-scroll-table', {
            [size]: !!size,
        }), style: style },
        renderHeader(),
        createElement("div", { className: "rows" }, renderContent())));
});
export default class DataVScrollTable extends React.Component {
    ref;
    constructor(props) {
        super(props);
        this.ref = React.createRef();
    }
    render() {
        return createElement(ScrollTable, { ...this.props, ref: this.ref });
    }
}
